import styled from 'styled-components';
import { SideNavColorSchemeProps, SideNavColorSchemeIndex } from '..';
import { localTheme } from '../../../styles/local-theme';

interface StyledCategoryItemProps extends SideNavColorSchemeProps {
  isActive?: boolean;
}

const bgColorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.fiord,
  blue: localTheme.colors.lochmara,
};

const arrowBackgroundColorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.spaceBlack,
  blue: localTheme.colors.lqBlue,
};

const arrowBorderColorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.pureBlack,
  blue: localTheme.colors.darkBlue,
};

const StyledCategoryItem = styled.div<StyledCategoryItemProps>`
  background-color: ${(props): string =>
    props.isActive ? bgColorSchemes[props.colorScheme] : 'none'};
  height: 4.8rem;
  font-weight: ${(props): number =>
    props.isActive
      ? props.theme.fontWeight.bold
      : props.theme.fontWeight.medium};
  padding: ${(props): string => props.theme.spaces.md} 0.8rem;
  border-bottom: ${(props): string =>
    props.isActive
      ? '0.1rem solid' + props.theme.colors.regentGray
      : '0.1rem solid transparent'};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  :hover {
    cursor: pointer;
    font-weight: ${(props): number => props.theme.fontWeight.bold};
    background-color: ${(props): string => bgColorSchemes[props.colorScheme]};
  }
  ::before {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border-top: 2.4rem solid transparent;
    border-right: 1rem solid
      ${(props): string =>
        props.isActive
          ? arrowBackgroundColorSchemes[props.colorScheme]
          : 'transparent'};
    border-bottom: 2.4rem solid transparent;
    margin-left: 10.9rem;
    z-index: ${(props): number => props.theme.zIndexFloor.two};
  }
  ::after {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border-top: 2.4rem solid transparent;
    border-right: 1.1rem solid
      ${(props): string =>
        props.isActive
          ? arrowBorderColorSchemes[props.colorScheme]
          : 'transparent'};
    border-bottom: 2.4rem solid transparent;
    margin-right: -0.9rem;
    margin-left: 10.7rem;
    z-index: ${(props): number => props.theme.zIndexFloor.one};
  }
`;

export default StyledCategoryItem;
